

























































































































































































































import {Component, Vue} from "vue-property-decorator";
import {Action} from "vuex-class";
import {EmailDetailItemInfo} from "@/store/email/statistic/types";
import EmailPreviewDialog from '@/components/Email/EmailPreviewDialog.vue';
import EmailEventsDetail from '@/components/Email/EmailEventsDetail.vue';
import {colorClassByStatus, formatAsJson} from "@/utils/page-utils";
import {dateFilter} from "@/utils/date-util";
import {notifyError} from "@/utils/notify-helper";
import {ActionLog} from "@/store/auth/types";
import {MsgTransports} from "@/store/types";
import {getTranslatedParams} from "@/utils/notify-utils";
import {InputWings, TextareaWings} from "wings-ui-components";

@Component({
  components: {EmailPreviewDialog, EmailEventsDetail, InputWings, TextareaWings},
  filters: {dateFilter},
  methods: {colorClassByStatus, formatAsJson}
})
export default class EmailDetailInfo extends Vue {
  @Action("getEmailStatisticDetailInfo") actionGetStatisticDetailInfo: any;
  @Action("getEmailMessage") actionGetMessage!: any;
  @Action("actionLog") actionLog: any;

  logObject: ActionLog = {};
  private transport = MsgTransports.EMAIL;

  defaultInfo(): EmailDetailItemInfo {
    return new EmailDetailItemInfo()
  }

  private messageInfo = this.defaultInfo();

  async created() {
    if (this.$route.params.id) {
      try {
        this.logObject = {
          actionPage: this.$route.meta.msgKey,
          action: "Viewing",
          actionStatus: 'success',
          objectType: "Message",
          addititionalInfo: getTranslatedParams({channel: this.transport, message_id: this.$route.params.id})
        }
        const resp = await this.actionGetStatisticDetailInfo(this.$route.params.id);
        await this.actionLog(this.logObject);
        this.messageInfo = Object.assign({}, this.messageInfo, resp.data);
      } catch(error) {
        await this.actionLog({...this.logObject, actionStatus: 'failed'})
        notifyError(error);
      }
    }
  }

  back(): void {
    this.$router.push('/report/detailed/email');
  }

  private messageContent: string|null = null;
  private showMessage: boolean = false;

  async showMessageContent(id: string) {
    try {
      this.messageContent = await this.actionGetMessage(id);
      this.showMessage = true
    } catch(error) {
      notifyError(error);
    }
  }

}
